import { Box, HStack } from "@chakra-ui/react";
import type { StatusVariant } from "./StatusVariant";

const TEXT_TOKEN: Record<StatusVariant, string> = {
  ok: "smStatusOkText",
  issue: "smStatusIssueText",
  neutral: "smMuted",
};

export const StatusDotLabel = ({ variant, label }: { variant: StatusVariant; label: string }) => (
  <HStack
    as="span"
    display="inline-flex"
    spacing="1.5"
    align="center"
    color={TEXT_TOKEN[variant]}
    fontSize="sm"
    fontWeight="medium"
    flexShrink={0}
  >
    <Box
      as="span"
      w="1.5"
      h="1.5"
      rounded="full"
      bg={variant === "neutral" ? "transparent" : "currentColor"}
      borderWidth={variant === "neutral" ? "1.5px" : undefined}
      borderColor={variant === "neutral" ? "currentColor" : undefined}
    />
    <Box as="span">{label}</Box>
  </HStack>
);
